import { bindingMode } from 'aurelia-binding';
import { bindable } from 'aurelia-templating';
import { customElement, PLATFORM, useView } from 'aurelia-framework';

@customElement('font-selector')
@useView(PLATFORM.moduleName('./font-selector.html'))
export class FontSelector {
  @bindable({ defaultBindingMode: bindingMode.twoWay })
  value: string;

  @bindable
  label: string;

  fonts = [
    { label: 'Arial', value: 'Arial' },
    { label: 'Courier', value: 'Courier New' },
    { label: 'Times New Roman', value: 'Times New Roman' },
    { label: 'Laica', value: 'Laica' },
    { label: 'Geita', value: 'Geita' }
  ];
}
